import React, { useState, useEffect } from 'react'
import styles from './filters.m.scss'
import fr from 'locales/fr.yaml'
import { useHistory } from 'react-router-dom'

const localisationStrings = { fr }
const isMobile = window.innerWidth < 768

export const Filters = ({ markers, handleFilter, locale }) => {
  const history = useHistory()
  const filtersList = new Map(
    markers.reduce((a, b) => {
      if (b.filters) {
        a = [
          ...a,
          ...b.filters.map(f => [f.name, { type: f.type, value: false }])
        ]
      }
      return a
    }, [])
  )

  const [filters, setFilters] = useState(new Map())
  const [showFilters, setShowFilters] = useState(false)

  const mainFiltersFilters = new Map(
    [...filters].filter(([k, v]) => v.type === 'mainFilters')
  )
  const accessFilters = new Map(
    [...filters].filter(([k, v]) => v.type === 'access')
  )

  useEffect(() => {
    setFilters(filtersList)
  }, [markers])

  useEffect(() => {
    // Construct a list of the active filters for this user
    const userActiveFilters = [...filters]
      .filter(([k, { value }]) => value === true)
      .map(([k, v]) => k)

    // Find only the relevant markers, according to the filters
    const filteredMarkers = markers.filter(m => {
      if (m.filters) {
        // Construct a list of the active filters for this marker
        const markerActiveFilters = m.filters
          .filter(f => f.value === true)
          .reduce((a, b) => [b.name, ...a], [])

        // Check if all of this marker filters are in the list of active filters
        return userActiveFilters.every(r => markerActiveFilters.includes(r))
      } else {
        return false
      }
    })

    handleFilter(userActiveFilters.length > 0 ? filteredMarkers : markers)
  }, [filters])

  return (
    <div className={styles.filtersContainer}>
      <div
        className={`menu-button ${showFilters ? 'active' : ''}`}
        onClick={() => {
          setShowFilters(!showFilters)
          history.replace('/')
        }}
      >
        Filtrer
        <i style={{ fontSize: '0.65em' }} className='ui icon chevron down' />
      </div>
      {showFilters && (
        <div className={styles.list}>
          <div>
            <div className={styles.groupTitle}>
              <b>Critères</b>
            </div>
            {[...mainFiltersFilters].map(([filter, { type, value }]) => (
              <div
                key={`filter-${filter}`}
                className={`${styles.filter} ${value && styles.filterActive}`}
                onClick={() => {
                  window.scrollTo(
                    0,
                    document
                      .getElementById('map-container')
                      .getBoundingClientRect().top + window.scrollY
                  )
                  setFilters(
                    new Map([...filters.set(filter, { type, value: !value })])
                  )
                }}
              >
                <div className={styles.checkboxIcon}>
                  <i
                    className={`ui icon circle ${value ? 'check' : 'outline'}`}
                  />
                </div>
                <div
                  className={`${styles.filterText} ${value &&
                    styles.filterTextActive}`}
                >
                  {localisationStrings[locale][filter]}
                  <div className={styles.description}>
                    {localisationStrings[locale].filtersDescription[filter]}
                  </div>
                </div>
              </div>
            ))}
          </div>
          {accessFilters.size > 0 && (
            <div>
              <div className={styles.groupTitle}>
                <b>Accès</b>
              </div>
              {[...accessFilters].map(([filter, { type, value }]) => (
                <div
                  key={`filter-${filter}`}
                  className={`${styles.filter} ${value && styles.filterActive}`}
                  onClick={() => {
                    window.scrollTo(
                      0,
                      document
                        .getElementById('map-container')
                        .getBoundingClientRect().top + window.scrollY
                    )
                    setFilters(
                      new Map([...filters.set(filter, { type, value: !value })])
                    )
                  }}
                >
                  <div className={styles.checkboxIcon}>
                    <i
                      className={`ui icon check square ${
                        value ? '' : 'outline'
                      }`}
                    />
                  </div>
                  <div
                    className={`${styles.filterText} ${value &&
                      styles.filterTextActive}`}
                  >
                    {localisationStrings[locale][filter]}
                    <div className={styles.description}>
                      {localisationStrings[locale].filtersDescription[filter]}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
          <div
            className='apply-button'
            onClick={() => {
              setShowFilters(false)
              history.replace('/')
            }}
          >
            Fermer
          </div>
        </div>
      )}
    </div>
  )
}
